import { render, staticRenderFns } from "./Evidences.vue?vue&type=template&id=21461c2c&scoped=true"
import script from "./Evidences.vue?vue&type=script&lang=js"
export * from "./Evidences.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21461c2c",
  null
  
)

export default component.exports